import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Tooltip from '@material-ui/core/Tooltip';
import {NavLink} from "react-router-dom";
import InfoIcon from '@material-ui/icons/Info';
import noimage from '../../assets/images/noimage.jpg'

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 500,
        minHeight: 185,
        height: 'auto',
        maxHeight: 450,
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
        marginRight: 10,
    },
});

function AuditsGridList(props) {
    const { classes } = props;

    return (
        <div className={classes.root}>
            <GridList cellHeight={180} className={classes.gridList}>
                {props.audits.map(audit => (
                    <GridListTile key={audit.id}>
                        <img src={audit.preview ? audit.preview.path : noimage} alt={audit.reference} />
                        <GridListTileBar
                            title={<Tooltip title={"Référence de l'audit :" + audit.reference} placement="top"><span>{audit.reference}</span></Tooltip>}
                            subtitle={<Tooltip title={"Raison sociale de l'entreprise : " + audit.company.name + ", Référence : " + audit.company.reference}><span>{audit.company.name + " (" + audit.company.reference +  ")"}</span></Tooltip>}
                            actionIcon={
                                <Tooltip title="Voir l'audit" placement="right">
                                    <NavLink to={"/audits/" + audit.id}>
                                        <InfoIcon className={classes.icon} />
                                    </NavLink>
                                </Tooltip>
                            }
                        />
                    </GridListTile>
                ))}
            </GridList>
        </div>
    );
}

AuditsGridList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuditsGridList);


// WEBPACK FOOTER //
// ./src/component/utils/AuditsGridList.js